export const bookingDesktopUpSize = 1280
export const bookingDesktopDownSize = 1279.98

export const bookingDesktopUp = '@media (min-width: 1280px)'
export const bookingDesktopDown = '@media (max-width: 1279.98px)'
